<template>
    <div class="row pt-3" style="border-top: 1px dashed rgba(106, 113, 133, 0.3);">
        <div class="col-sm-6 ">
            <div class=" mt-3 checkbox-checked h-100 d-flex h-100 align-items-center">
                <div class="form-check ">
                    <input class="form-check-input" id="scaleItem" type="checkbox" value=""
                        v-model="compState.scaleItem">
                    <label class="form-check-label" for="scaleItem">Scale Item</label>
                </div>
            </div>
        </div>

        <div class=" col-sm-6">
            <label>
                <h6 class="f-w-700">Stock Low Watermark</h6>
            </label>
            <div class="input-group">
                <input class="form-control" type="number" placeholder="Threshold"
                    v-model="compState.weightDecimalPlaces">
                <button class="btn btn-outline-secondary rounded-end-0" type="button"
                    @click="weightDecimalPlacesDecrement">-</button>
                <button class="btn btn-outline-secondary rounded-start-0" type="button"
                    @click="weightDecimalPlacesIncrement">+</button>
            </div>
        </div>
        <div class=" col-sm-6">
            <label>
                <h6 class="f-w-700">Stock High Watermark</h6>
            </label>
            <div class="input-group">
                <input class="form-control" type="number" placeholder="Threshold" v-model="compState.scaleMultiplier">
                <button class="btn btn-outline-secondary rounded-end-0" type="button"
                    @click="scaleMultiplierDecrement">-</button>
                <button class="btn btn-outline-secondary rounded-start-0" type="button"
                    @click="scaleMultiplierIncrement">+</button>
            </div>
        </div>
        <div class=" col-sm-6">
            <label>
                <h6 class="f-w-700">Sale to Stock Unit Ratio</h6>
            </label>
            <div class="input-group">
                <input class="form-control" type="number" placeholder="Threshold" v-model="compState.tare">
                <button class="btn btn-outline-secondary rounded-end-0" type="button" @click="tareDecrement">-</button>
                <button class="btn btn-outline-secondary rounded-start-0" type="button"
                    @click="tareIncrement">+</button>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { computed, reactive, watch, onMounted } from 'vue'
import { useProductsStore } from '@/store/management/productsStore';

const productStore = useProductsStore()

onMounted(() => {
    if (tempActiveProduct.value?.basic.productNumber) {
        const productGroup = tempActiveProduct.value
        const scaleData = productGroup.scale
        compState.scaleItem = scaleData.scaleItem
        compState.weightDecimalPlaces = scaleData.weightDecimalPlaces
        compState.scaleMultiplier = scaleData.scaleMultiplier
        compState.tare = scaleData.tare
    }
})

const compState = reactive({
    scaleItem: false,
    weightDecimalPlaces: 0,
    scaleMultiplier: 0,
    tare: 0
})


const activeProduct = computed(() => {
    return productStore.getActiveProduct
})

const tempActiveProduct = computed(() => {
    return productStore.getTempActiveProduct
})

const activeProductId = computed(() => {
    return productStore.getActiveProductId
})

watch(activeProductId, (newVal) => {
    if (newVal) {
        const productGroup = activeProduct.value
        const scaleData = productGroup.scale
        compState.scaleItem = scaleData.scaleItem
        compState.weightDecimalPlaces = scaleData.weightDecimalPlaces
        compState.scaleMultiplier = scaleData.scaleMultiplier
        compState.tare = scaleData.tare
    }
}, { immediate: true });

watch(compState, (newVal) => {
    productStore.setTempActiveProduct({
        ...tempActiveProduct.value,
        scale: {
            scaleItem: newVal.scaleItem,
            weightDecimalPlaces: newVal.weightDecimalPlaces,
            scaleMultiplier: newVal.scaleMultiplier,
            tare: newVal.tare
        }
    })

}, { deep: true });

const weightDecimalPlacesDecrement = () => {
    compState.weightDecimalPlaces++
}

const weightDecimalPlacesIncrement = () => {
    if (compState.weightDecimalPlaces > 0) {
        compState.weightDecimalPlaces--
    }
}
const scaleMultiplierDecrement = () => {
    compState.scaleMultiplier++
}

const scaleMultiplierIncrement = () => {
    if (compState.scaleMultiplier > 0) {
        compState.scaleMultiplier--
    }
}
const tareDecrement = () => {
    compState.tare++
}

const tareIncrement = () => {
    if (compState.tare > 0) {
        compState.tare--
    }
}

</script>

<style scoped lang="scss">
.destination-container {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 1rem;
}

.hover-pointer {
    cursor: pointer;
}

.nav-link {
    color: var(--bs-heading-color);
}
</style>